import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/frame/NotFound'

/**
 * 介绍
 */
import homeIndex from '@/pages/newWebsite/main/main'
import aboutUs from '@/pages/newWebsite/main/aboutUs'
import Solution from '@/pages/newWebsite/main/solution.vue'
import cooperation from '@/pages/newWebsite/main/cooperation.vue'
import OpenApi from '@/pages/newWebsite/main/openApi.vue'
import Doc from '@/pages/newWebsite/main/components/doc.vue'
import Interface from '@/pages/newWebsite/main/components/interface.vue'

/**
 * 新版b2b
 */

import NewHome from '@/pages/newPages/booking/home'
import Register from '@/pages/newPages/login/register'
import RegisterForm from '@/pages/newPages/login/registerForm'
import ReisterSuccess from '@/pages/newPages/login/registerSuccess'
import Login from '@/pages/newPages/login/login'
import HomeSearch from '@/pages/newPages/booking/HomeSearch'
import HotelList from '@/pages/newPages/booking/hotelList'
import HotelDetail from '@/pages/newPages/booking/HotelDetail'
import bookingDetail from '@/pages/newPages/booking/BookingDetail'
import cashier from '@/pages/newPages/booking/Cashier'
import orderManage from '@/pages/newPages/order/orderManage'
import AccountInfo from '@/pages/newPages/order/AccountInfo'
import AccountSetting from '@/pages/newPages/order/AccountSetting'
import OrderList from '@/pages/newPages/order/OrderList'
import BillDeatil from '@/pages/newPages/order/BillDeatil'
import HotelBill from '../pages/newPages/order/HotelBill.vue'
import Contacts from '@/pages/newPages/order/Contacts'
import SubAccount from '@/pages/newPages/order/SubAccount'
import OrderDetail from '@/pages/newPages/order/OrderDetail'
import TermsofService from '@/pages/newPages/booking/TermsofService'
import WorkOrderManage from '@/pages/newPages/order/WorkOrderManage'
import HotelConfirmOrder from '../pages/newPages/order/components/HotelConfirmOrder.vue'
import InvoiceManage from '../pages/newPages/order/InvoiceManage.vue'
import UserInvoiceManage from '../pages/newPages/order/components/UserInvoiceManage.vue'
import InvoiceDetail from '../pages/newPages/order/components/InvoiceDetail.vue'
import InvoiceList from '../pages/newPages/order/components/invoiceList.vue'
import ssoLogin from '../pages/sso/login.vue'
import hotelBillDetail from '../pages/newPages/order/components/HotelBillDetail.vue'


const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from) {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '',
    redirect: '/view/index'
  },
  {
    path: '/view/index',
    component: homeIndex,
    children: [{
      path: '',
      redirect: 'aboutUs'
    }, {
      path: 'aboutUs',
      component: aboutUs
    }, {
      path: 'solution',
      component: Solution
    }, {
      path: 'openApi',
      component: OpenApi,
      children: [{path: 'doc', component: Doc}, {path: 'interface', component: Interface}]
    }, {
      path: 'cooperation',
      component: cooperation
    }]
  },
  {
    path: '/sso/login',
    component: ssoLogin
  },
  {
    path: '/NewHome',
    component: NewHome,
    children: [
      { path: '', redirect: 'HomeSearch' },
      { path: 'HomeSearch', component: HomeSearch }
    ]
  },
  {
    path: '/Register',
    component: Register,
    children: [{
      path: '',
      redirect: 'form'
    }, {
      path: 'form',
      component: RegisterForm
    }, {
      path: 'success',
      component: ReisterSuccess
    }]
  },
  {
    path: '/Login',
    component: Login
  },
  {
    path: '/HotelList',
    name: 'HotelList',
    component: HotelList
  },
  {
    path: '/HotelDetail',
    name: 'HotelDetail',
    component: HotelDetail
  },
  {
    path: '/bookingDetail',
    name: 'bookingDetail',
    component: bookingDetail
  },
  {
    path: '/cashier',
    name: 'cashier',
    component: cashier
  },
  {
    path: '/orderManage',
    component: orderManage,
    children: [
      {
        path: '',
        redirect: 'OrderList'
      },
      {
        path: 'AccountInfo',
        component: AccountInfo
      },
      {
        path: 'AccountSetting',
        component: AccountSetting
      },
      {
        path: 'OrderList',
        component: OrderList
      },
      {
        path: 'BillDeatil',
        component: BillDeatil
      },
      {
        path: 'hotelBill',
        component: HotelBill
      },
      {
        path: 'Contacts',
        component: Contacts
      },
      {
        path: 'SubAccount',
        component: SubAccount
      },
      {
        path: 'WorkOrderManage',
        component: WorkOrderManage
      },
      {
        path: 'invoiceManage',
        component: InvoiceManage
      },
      {
        path: 'userInvoiceManage',
        component: UserInvoiceManage
      },
      {
        path: 'invoiceList',
        component: InvoiceList
      }
    ]
  },
  {
    path: '/orderDetail',
    component: OrderDetail
  },
  {
    path: '/TermsofService',
    component: TermsofService
  },
  {
    path: '/HotelConfirmOrder',
    component: HotelConfirmOrder
  },
  {
    path: '/hotelBillDetail',
    component: hotelBillDetail
  },
  {
    path: '/invoiceDetail',
    component: InvoiceDetail
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound
  },
  {
    path: '*', // 页面不存在的情况下会跳到404页面
    redirect: '/404'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js